// Standard library imports
import React, { useContext, useEffect, useState } from 'react';

// External library imports
import { useLocation, useHistory } from 'react-router-dom';
import _, { get as LodashGet } from 'lodash';

// Internal module imports
import TabsComponent from '../../components/Tabs/Tabs';
import { AuthContext } from '../../context/AuthContext';
import { LoaderContext } from '../../context/LoaderContext';
import { START_LOADER, STOP_LOADER } from '../../constants';
import Details from './Details/Details';
import { sortByName } from '../../utils/objectHelper';
import { LicenseService } from '../../services/LicenseService';
import { momentTimeFormater } from '../../utils/dateHelper';
import moment from 'moment';
import InfoIcon from '../../assets/info.svg';
import Alerts from './Alerts/Alerts';
import CustomTooltip from '../../components/CustomToolTip/CustomTooltip';
import AllInstances from './AllInstances/AllInstances';

// Css module imports
import classes from '../SmartCharging/SmartCharging.module.css';
import Events from './Events/Events';

const getFrequencySignalMap = (customer) => {
    const { frequency = [] } = customer;
    const map = [];
    frequency.forEach((f) => (map[f._id] = f.name));
    return map;
};

const BESS2E3App = () => {
    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);

    const { state } = useContext(AuthContext);
    const customer = LodashGet(state, 'user.customerId');
    const licenseTypeId = state.isAuthorized ? queryParams.get('licenseTypeId') : '';

    const enabledLicense = LodashGet(state, `user.customerId.enabledLicense.${licenseTypeId}`);
    const settings = enabledLicense?.settings;
    const tabSettings = {
        overview: settings?.overview ? settings.overview : false,
        events: settings?.events ? settings.events : false,
        alerts: settings?.alerts ? settings.alerts : false,
        details: settings?.details ? settings.details : false,
    };

    const activeTabs = Object.values(settings).reduce((acc, active) => (acc += active ? 1 : 0), 0)

    const { dispatch: loaderDispatch } = useContext(LoaderContext);
    const startLoader = (payload) => loaderDispatch({ type: START_LOADER, payload });
    const stopLoader = (payload) => loaderDispatch({ type: STOP_LOADER, payload });

    const [queryParamsData] = useState({
        subTab: queryParams.get('subTab') ? Number(queryParams.get('subTab')) : '',
        tab: queryParams.get('tab') ? Number(queryParams.get('tab')) : '',
        date: queryParams.get('date') ? new Date(queryParams.get('date')) : '',
        dateRange: queryParams.get('dateRange') ? JSON.parse(queryParams.get('dateRange')) : '',
        group: queryParams.get('group') ? JSON.parse(queryParams.get('group')) : '',
        createAlertModal: queryParams.get('createAlertModal') && queryParams.get('createAlertModal') === 'true' ? Boolean(queryParams.get('createAlertModal')) : false,
    });
    const [open, setOpen] = useState(false);
    const [selectedOuterIndex, setSelectedOuterIndex] = useState(queryParamsData.tab ? queryParamsData.tab : 0);

    const updateQueryParams = (type, value) => {
        let queryParamsNew = queryParams;
        if (type === 'tab') {
            const licenseTypeId = queryParamsNew.get('licenseTypeId');
            queryParamsNew = new URLSearchParams();
            queryParamsNew.set('licenseTypeId', licenseTypeId);
        }
        queryParamsNew.set(type, value);
        history.push({ search: queryParamsNew.toString() });
    };
    const [licenseTypeHash, setLicenseTypeHash] = useState({});
    const [licenseDetails, setLicenseDetails] = useState({});
    const [groups, setGroups] = useState([]);
    const [device, setDevice] = useState({
        name: '',
        _id: '',
    });
    const [refresh, setRefresh] = useState({});
    const [customerFrequencyMap] = useState(getFrequencySignalMap(customer));
    const [selectedIndex, setSelectedIndex] = useState(queryParamsData.subTab ? queryParamsData.subTab : 0);

    useEffect(() => {
        if (licenseTypeHash[licenseTypeId]) {
            const licenseDetail = licenseTypeHash[licenseTypeId];
            setLicenseDetails({
                _id: licenseDetail._id,
                type: licenseDetail.name,
                groups,
            });
        }
    }, [licenseTypeHash, groups]);

    useEffect(() => {
        if (licenseTypeId) {
            fetchLicenseTypes();
            LicenseService.getLicenseTypeDetails(
                customer._id,
                licenseTypeId,
                { date: momentTimeFormater(moment()).format() },
                () => startLoader('getInstances'),
                handleGetInstanceSuccess,
                handleError,
                () => stopLoader('getInstances')
            );
        }
    }, [licenseTypeId]);

    const fetchLicenseTypes = () => {
        LicenseService.getLicenseTypes(
            () => startLoader('getInstances'),
            handleLicenseTypesSuccess,
            handleError,
            () => stopLoader('getInstances')
        );
    };

    const handleLicenseTypesSuccess = ({ data }) => {
        const licenseTypesHash = {};
        data?.data.forEach((type) => {
            licenseTypesHash[type._id] = type;
        });
        setLicenseTypeHash(licenseTypesHash);
    };

    useEffect(() => {
        if (licenseTypeId) {
            LicenseService.getLicenseTypeDetails(
                customer._id,
                licenseTypeId,
                { date: momentTimeFormater(moment()).format() },
                () => startLoader('getInstances'),
                handleGetInstanceSuccess,
                handleError,
                () => stopLoader('getInstances')
            );
        }
    }, [licenseTypeId]);


    const handleError = (err) => {
        console.log(err);
    };

    const handleGetInstanceSuccess = ({ data }) => {
        let allGroupsArray = data.data;
        allGroupsArray = sortByName(allGroupsArray);
        let processedGroups = allGroupsArray.map((device) => {
            device.hyperlink = (
                <div className="link" onClick={() => setDevice(device)}>
                    {device.name}
                </div>
            );
            device.populatedFrequency = (
                <div>
                    {customerFrequencyMap[device.properties?.frequencySignal] ? (
                        customerFrequencyMap[device.properties?.frequencySignal]
                    ) : (
                        <CustomTooltip content={`Frequency Signal with id "${device.properties?.frequencySignal}" is not enabled`}>
                            <div style={{ display: 'flex', gridColumnGap: '1vw', justifyContent: 'center' }}>
                                <img className={classes.ActionIcon} src={InfoIcon} alt="" />
                            </div>
                        </CustomTooltip>
                    )}
                </div>
            );

            return device;
        });

        setGroups(processedGroups.flat());
    };

    let tabs = [
        ...(tabSettings.overview
            ? [
                {
                    name: 'Overview',
                    component: (
                        <Details
                            device={device}
                            setDevice={setDevice}
                            setRefresh={setRefresh}
                            license={groups}
                            startLoader={startLoader}
                            stopLoader={stopLoader}
                            updateQueryParams={updateQueryParams}
                            queryParamsData={queryParamsData}
                        />
                    ),
                },
            ]
            : []),
        ...(tabSettings.alerts
            ? [
                {
                    name: 'Alerts',
                    component: (
                        <Alerts
                            license={licenseDetails}
                            startLoader={startLoader}
                            stopLoader={stopLoader}
                            updateQueryParams={updateQueryParams}
                            queryParamsData={queryParamsData}
                        />
                    ),
                },
            ]
            : []),
        ...(tabSettings.details
            ? [
                {
                    name: 'Details',
                    component: (
                        <div className="ventilation">
                            <TabsComponent
                                onChangeTab={(index) => {
                                    setSelectedIndex(index);
                                    updateQueryParams('subTab', index);
                                }}
                                selectedIndex={selectedIndex}
                                tabs={[
                                    {
                                        name: 'All Instances',
                                        component: <AllInstances devices={groups} />,
                                    },
                                ]}
                            />
                        </div>
                    ),
                },
            ]
            : []),
        ...(tabSettings.events
            ? [
                {
                    name: 'Events',
                    component: (
                        <Events
                            instances={groups}
                            licenseTypeId={licenseTypeId}
                            updateQueryParams={updateQueryParams}
                            queryParamsData={queryParamsData}
                        />
                    ),
                },
            ]
            : [])

    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <div className={classes.Ventilation + ' ventilation'}>
                <TabsComponent
                    selectedIndex={selectedOuterIndex}
                    tabs={tabs}
                    isOpen={open}
                    setOpen={setOpen}
                    onChangeTab={(index) => {
                        setSelectedOuterIndex(index);
                        updateQueryParams('tab', index);
                    }}
                />
            </div>
        </div>
    );
};

export default BESS2E3App;
